import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Contacts, Proctor } from '../models/contacts';

@Injectable({
  providedIn: 'root',
})
export class AdminsAndProctorsService {
  constructor(private httpClient: HttpClient) {}

  public leadAdmins$: BehaviorSubject<Contacts[]> = new BehaviorSubject<
    Contacts[]
  >([]);
  public peopleType$: BehaviorSubject<any> = new BehaviorSubject<any>('');
  getLeadAdmins2(locationId: string) {
    return this.httpClient
      .get<any>(
        environment.baseURL +
          "odata/Contacts/LeadAdmins(locationId='" +
          locationId +
          "')"
      )
      .subscribe((people) => {
        this.leadAdmins$.next(people.value);
      });
  }

  public studentAdmins$: BehaviorSubject<Contacts[]> = new BehaviorSubject<
    Contacts[]
  >([]);
  getStudentAdmins2(locationId: string) {
    return this.httpClient
      .get<any>(
        environment.baseURL +
          "odata/Contacts/StudentAdmins(locationId='" +
          locationId +
          "')"
      )
      .subscribe((peoples) => {
        this.studentAdmins$.next(peoples.value);
      });
  }

  public proctors$: BehaviorSubject<Proctor[]> = new BehaviorSubject<Proctor[]>(
    []
  );
  getProctors2(locationId: string) {
    return this.httpClient
      .get<any>(
        environment.baseURL +
          "odata/Contacts/Proctors(locationId='" +
          locationId +
          "')"
      )
      .subscribe((peoples) => {
        this.proctors$.next(peoples.value);
      });
  }
}
